'use strict'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import vuex from 'vuex'
// import eruda from 'eruda'
import './assets/iconfont/iconfont.css'

import common from '@/common'

Vue.config.productionTip = false

// eruda.init()

Vue.use(common)
Vue.use(vuex)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh', // 默认语言 可以借助cookie来设置和获取本地语言环境 从而加载不同的语言文件
  messages: {
    zh: require('@/assets/lang/zh_CN'),
    en: require('@/assets/lang/en'),
    tc: require('@/assets/lang/tc')
  }
})
Vue.prototype.$getFormat = function (a, ...b) {
  let text = a
  for (let i = 0; i < b.length; i++) {
    text = text.replace(new RegExp('\\{' + i + '\\}'), b[i])
  }
  return text
}
Vue.prototype.$setDepositTerm = function (str) {
  const a = str[0]
  const b = str.substr(1)
  let result
  result = b
  let c
  switch (a) {
    case 'Y': c = b === '1' ? this.$t('label.label205') : this.$t('label.label208')
      break
    case 'M': c = b === '1' ? this.$t('label.label206') : this.$t('label.label209')
      break
    case 'D': c = b === '1' ? this.$t('label.label207') : this.$t('label.label210')
      break
    default : c = ''
  }
  result += c
  return result
}
Vue.prototype.$exchangeLang = function (lang) {
  let result
  switch (lang) {
    case 'en_US': result = 'en_US'
      break
    case 'zh_CN': result = 'zh_CN'
      break
    case 'zh_HK': result = 'zh_TW'
      break
  }
  return result
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
